import apifetch, {
  tokenStore,
} from "CommonCore/apifetch";
import {
  inline,
} from "CommonState/action-helpers";
import {
  getUserUiconfig,
} from "State/auth";
import {
  ENDPOINT_LOGIN,
  ENDPOINT_LOGOUT,
  ENDPOINT_REFRESH,
  ENDPOINT_REGISTER,
} from "App/constants";
import {
  history,
} from "CommonState/store";


function cacheUser(dispatch, user, ticket) {
  if (user) {
    tokenStore.set(user, ticket);
  } else {
    tokenStore.del(ticket);
  }

  dispatch(inline("user", state => state.user = user));

  let uiconfig;
  if (user) {
    uiconfig = getUserUiconfig(user);
  } else {
    dispatch({ type: "CLEAR" });
  }
  dispatch(inline("uiconfig", state => state.uiconfig = uiconfig));
}

export function refreshLoginToken(serverinfo) {
  return async function(dispatch) {
    const ticket = tokenStore.getTicket();
    let result = null;
    if (tokenStore.get()) {
      try {
        result = await apifetch(ENDPOINT_REFRESH, { method: "POST" });
      } catch(e) {
        return;
      }
    }

    if (result) {
      result.serverinfo = serverinfo;
    }

        // let decoded = jwt_decode(result.token)

    cacheUser(dispatch, result, ticket);
  };
}

export function login(user, password, serverinfo) {
  return async function(dispatch) {
    const ticket = tokenStore.getTicket();
    let result = null;

    const response = await fetch(ENDPOINT_LOGIN, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ login: user, password }),
    });
    if (response.status >= 500) {
      return { ec: "1", um: "Serverfehler" };
    }
    if (response.status >= 400 && response.status < 500) {
      const json = await response.json();
      return { ec: "2", um: json.um || "Anmeldefehler" };
    }
    const json = await response.json();
    result = json;

    const doCache = user => {
      cacheUser(dispatch, user, ticket);
    };
        // Daten vollständig?
    if (result.name && result.vorname) {
            // Ja, cachen und damit Anmeldung abschließen
      result.serverinfo = serverinfo; // Serverinfo merken
      doCache(result);
    } else {
            // Aufrufende Stelle informieren, dass noch Profildaten fehlen
      result.needProfileData = true;
      result.onProfileOk = doCache;
    }
    return result;
  };
}

export function register(user, password, name, vorname, email) {
  return async function() {
    tokenStore.getTicket();
    let result = null;

    const response = await fetch(ENDPOINT_REGISTER, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ login: user, password, name, vorname, email }),
    });
    if (response.status >= 400) {
      const json = await response.json();
      throw Error(json.um);
    } else {
      result = { ok: true };
    }
    return result;
  };
}

export function logout() {
  return async function(dispatch) {
        // history löschen
    history.replace("/");
    await apifetch(ENDPOINT_LOGOUT, { method: "POST" });
    cacheUser(dispatch, null, tokenStore.getTicket());
        // history löschen
    history.push("/");
    history.go(0);
  };
}
